import { authSessionSchema, type AuthSession, type PhoneChallengeIntent } from '@secretario/shared';
import { clearSession, getDevice, writeSession } from '../session.js';
import { apiFetch, withDevice } from './http.js';

export type RequestedChallenge = {
  challengeId: string;
  expiresAt: string;
  delivery: { channel: 'sms'; destinationHint: string };
};

export function requestChallenge(phone: string, intent: PhoneChallengeIntent) {
  return apiFetch<RequestedChallenge>('/v1/auth/phone/challenges', {
    method: 'POST',
    body: { phone, intent },
    auth: false,
  });
}

type VerifyInput =
  | { intent: 'login'; challengeId: string; code: string }
  | {
      intent: 'register';
      challengeId: string;
      code: string;
      username: string;
      displayName: string;
    };

export async function verifyChallenge(input: VerifyInput): Promise<AuthSession> {
  const session = authSessionSchema.parse(
    await withDevice(() =>
      apiFetch<unknown>('/v1/auth/phone/verify', {
        method: 'POST',
        body: { ...input, device: getDevice() },
        auth: false,
      }),
    ),
  );
  writeSession(session);
  return session;
}

export async function logout(): Promise<void> {
  // Antes de encerrar: este aparelho deixa de receber avisos da conta.
  await Promise.all([import('../matrix/client.js'), import('../push.js')])
    .then(([matrix, push]) => push.unregisterPush(matrix.getMatrixClient()))
    .catch(() => {});
  try {
    await apiFetch<void>('/v1/auth/session', { method: 'DELETE' });
  } finally {
    await import('../matrix/client.js').then((m) => m.forgetMatrixClient()).catch(() => {});
    clearSession();
  }
}
